<template>
  <div class="container">
    <div
      :class="{'text-center': centered}">
      <default-button
        :dare_colors="dare_colors"
        :href="button_link">
        {{ button_text }}
      </default-button>
    </div>
  </div>
</template>

<script>
import DefaultButton from "../slots/DefaultButton.vue";

export default {
  name: "ButtonBlock",
  components: {DefaultButton},
  props: {
    /**props**/
    button_text: {
      type: String,
      default: '',
      required: true,
      admin_type: 'input',
    },
    button_link: {
      type: String,
      required: true,
      default: '',
      admin_type: 'input',
    },
    centered: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    dare_colors: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
}
</script>
